import { faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useRef, useState } from 'react'
import { Alert, Form } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useLang } from '../../../../../../../language'

import { Editor } from '@tinymce/tinymce-react';

import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';
import 'tinymce/plugins/code';
import 'tinymce/plugins/lists';

import 'tinymce/skins/ui/oxide/skin.min.css';
import { InputText } from '../../../../../../../components/Inputs'
import { useValidator } from '../../../../../../../hooks/useValidator'
import { LoaderForm } from '../LoaderForm'
import InputImage from '../../../../../../../components/Inputs/InputImage'
import { ModalCropImage } from '../../../../../../../components/Modals/ModalCropImage/ModalCropImage'
import { ButtonSpinner } from '../../../../../../../components/ButtonSpinner/ButtonSpinner'
import { AparatoServices } from '../controllers/services/aparato.service'
import { isStatusSucess } from '../../../../../../../helpers/helpers'
import { ModalStatusServer } from '../../../../../../../components/Modals/ModalStatusServer'
import { ModalConfirm } from '../../../../../../../components/Modals/ModalConfirm'
import { MsgInput } from '../../../../../../../components/MsgInput/MsgInput'

export const DatosGenerales = ({ idaparato, nuevo, formAparato, handleInputChangeAparato, handleFormChangeAparato,
    fetchAparatoGETData, fetchParamsIdiomasData }: any) => {

    const Lang = useLang()

    const inputFileFichero: any = useRef(null)

    const navigate = useNavigate()

    const [valuesValidationNoticia, handleValidationNoticia, handleResetValidationNoticia] = useValidator({
        producto: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
        descripcionidioma: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })


    const handleEditorChange = (content: any) => {

        const target = {
            name: 'descripcionidioma',
            value: content,
        }
        handleInputChangeAparato({ target })
    }

    // Modal nueva imagen

    const [showModal_NuevaImagen, setShowModal_NuevaImagen] = useState({
        value: false,
        payload: {}
    });

    const handleCloseModal_NuevaImagen = (payload: object) => setShowModal_NuevaImagen({
        value: false,
        payload: {}
    });

    const handleShowModal_NuevaImagen = (payload: object) => setShowModal_NuevaImagen({
        value: true,
        payload
    });


    // Modal Rercortar imagen

    const [InputFileImage, setInputFileImage] = useState([])

    const [showModalCropImage, setShowModalCropImage] = useState({
        value: false,
        payload: null
    });

    const handleCloseModalCropImage = () => setShowModalCropImage({
        value: false,
        payload: null
    })

    const handleShowModalCropImage = (payload: any) => setShowModalCropImage({
        value: true,
        payload
    });

    const handleChangeInputImage = (e: any) => {
        if (e.target.files.length > 0) {
            handleShowModalCropImage(e.target.files[0])
        }
    }

    const [fetchImagenPOST, fetchImagenPOSTData] = AparatoServices.POST_IMAGEN(idaparato)

    const handleSubirImagen = (tipo: any, file: any) => {

        // handleFormChangeAparato({
        //     ...formAparato,
        //     imagen: file
        // })

        fetchImagenPOST({
            body: {
                img: file
            }
        })
    }

    const [fetchPersonaDatGenDELETE_IMAGEN, fetchPersonaDatGenDELETE_IMAGENData] = AparatoServices.DELETE_IMAGE(idaparato)

    const handleEliminarImagen = (tipo: any) => {

        if (idaparato !== 'nuevo') {

            fetchPersonaDatGenDELETE_IMAGEN()
        }

        handleFormChangeAparato({
            ...formAparato,
            url_imagen: ''
        })
    }

    const handleDeleteAdjunto = () => {
        handleFormChangeAparato({
            ...formAparato,
            adjunto: []
        })
    }


    // Modal Adjunto

    // const [showModal_Fichero, setShowModal_Fichero] = useState({
    //     value: false,
    //     payload: {}
    // });

    // const handleCloseModal_Fichero = () => setShowModal_Fichero({
    //     value: false,
    //     payload: {}
    // });

    // const handleShowModal_Fichero = (payload: object) => setShowModal_Fichero({
    //     value: true,
    //     payload
    // });

    // --------------- POST aparato

    const [fetchAparatoPOST, fetchAparatoPOSTData] = AparatoServices.POST()

    const handleSubmitfetchAparatoPOST = () => {

        if (handleValidationNoticia(formAparato)) {

            fetchAparatoPOST({
                body: {
                    ...formAparato,
                    productoidioma: [
                        {
                            ididioma: fetchParamsIdiomasData.data?.[0]?.id,
                            descripcionidioma: formAparato.descripcionidioma,
                            productoidioma: formAparato.producto,
                        }
                    ]
                }
            })
        }

    }

    useEffect(() => {

        if (isStatusSucess(fetchAparatoPOSTData.status)) {

            const idproducto = fetchAparatoPOSTData.data?.data?.idproducto

            // resetDatosGenerales()

            navigate(`/alquiler-aparatos-admin/aparatos/${idproducto}`)
        }

    }, [fetchAparatoPOSTData])

    // --------------------- PATCH Aparato

    const [fetchAparatoPATCH, fetchAparatoPATCHData] = AparatoServices.PATCH(idaparato)

    const handleSubmitEditar = () => {

        fetchAparatoPATCH({
            body: {
                ...formAparato,
                productoidioma: [
                    {
                        ididioma: fetchParamsIdiomasData.data?.[0]?.id,
                        descripcionidioma: formAparato.descripcionidioma,
                        productoidioma: formAparato.producto,
                        idproductoidioma: formAparato.idiomas?.[0]?.idproductoidioma,
                    }
                ]
            }
        })

    }

    // ------------- DELETE Aparato

    const [fetchAparatoDELETE_BAJA, fetchAparatoDELETE_BAJAData] = AparatoServices.DELETE_BAJA(idaparato)

    const [showConfirm_DELETE, setshowConfirm_DELETE] = useState(false)

    useEffect(() => {

        if (isStatusSucess(fetchAparatoDELETE_BAJAData.status)) {
            setshowConfirm_DELETE(false)
            // fetchInscripcionGET()
            navigate(`/alquiler-aparatos-admin/aparatos`)

        }
    }, [fetchAparatoDELETE_BAJAData])

    const handleSubmitAparatoDELETE = () => {

        fetchAparatoDELETE_BAJA()
    }

    return (
        <div className="animate__animated animate__fadeInUp">

            <div className="px-4 py-3 card mb-4">

                {
                    (fetchAparatoGETData.loading) ? (
                        <div className="card p-3">
                            <LoaderForm />
                        </div>
                    ) :
                        (
                            <>
                                <div className="row">

                                    <div className="col-lg-8">

                                        <div className="row">

                                            <Form.Group className="col-12  mb-4">
                                                <InputText
                                                    label={`${Lang('NOMBRE')}:`}
                                                    name='producto'
                                                    value={formAparato.producto}
                                                    onChange={handleInputChangeAparato}
                                                    // fetchData={nuevo ? fetchNoticiaPOSTData : fetchNoticiaPATCHData}
                                                    validation={valuesValidationNoticia}
                                                />
                                            </Form.Group>

                                            <Form.Group className="col-12 mb-4">
                                                <Form.Label className='fw-500'>{`${Lang('DESCRIPCION')}:`}</Form.Label>

                                                <Editor
                                                    // initialValue={dataInicial}
                                                    init={{
                                                        skin: false,
                                                        branding: false,
                                                        content_css: false,
                                                        height: 500,
                                                        menubar: false,
                                                        plugins: [
                                                            'link image',
                                                            'table paste',
                                                            'code',
                                                            'lists',
                                                        ],
                                                        toolbar:
                                                            'undo redo | formatselect | bold italic underline backcolor forecolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help code'
                                                    }}
                                                    value={formAparato.descripcionidioma}
                                                    onEditorChange={handleEditorChange}

                                                />
                                                <MsgInput obj={valuesValidationNoticia} name='descripcionidioma' />

                                            </Form.Group>

                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="row">

                                            <Form.Group className="col-12  mb-4">
                                                <InputText
                                                    label={`${Lang('MODELO')}:`}
                                                    name='modelo'
                                                    value={formAparato.modelo}
                                                    onChange={handleInputChangeAparato}
                                                    // fetchData={nuevo ? fetchNoticiaPOSTData : fetchNoticiaPATCHData}
                                                    validation={valuesValidationNoticia}
                                                />
                                            </Form.Group>


                                            <Form.Group className="mb-3 col-12">
                                                <Form.Label className='fw-500'>{`${Lang('IMAGEN')}:`}</Form.Label>
                                                {
                                                    nuevo ? <Alert variant='danger' className='mb-0 p-3 text-center'>
                                                        <small>{Lang('ALERT_OPCION_DISPONIBLE_LUEGO_CREAR_APARATO')}</small>
                                                    </Alert> :
                                                        <InputImage
                                                            width='100%'
                                                            height='13rem'
                                                            onChange={handleChangeInputImage}
                                                            InputFile={InputFileImage}
                                                            setInputFile={setInputFileImage}
                                                            urlImage={formAparato.url_imagen}
                                                            handleEliminarImagen={() => handleEliminarImagen('fotografia')}
                                                        />
                                                }

                                            </Form.Group>

                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <h5 className='h6 border-bottom pb-2 mb-3'>{Lang('CONDICIONES')}</h5>
                                    </div>

                                    <Form.Group className="col-md-6 col-lg-4 mb-4">
                                        <InputText
                                            label={Lang('DIAS_MINIMOS') + ':'}
                                            name='diasminimos'
                                            value={formAparato.diasminimos}
                                            onChange={handleInputChangeAparato}
                                            // fetchData={nuevo ? fetchNoticiaPOSTData : fetchNoticiaPATCHData}
                                            validation={valuesValidationNoticia}
                                            type='number'
                                        />
                                    </Form.Group>

                                    <Form.Group className="col-md-6 col-lg-4 mb-4">
                                        <InputText
                                            label={Lang('DIAS_MAXIMOS') + ':'}
                                            name='diasmaximos'
                                            value={formAparato.diasmaximos}
                                            onChange={handleInputChangeAparato}
                                            // fetchData={nuevo ? fetchNoticiaPOSTData : fetchNoticiaPATCHData}
                                            validation={valuesValidationNoticia}
                                            type='number'
                                        />
                                    </Form.Group>

                                    <div className='col-12 mt-4 pt-3 d-flex justify-content-between border-top'>
                                        {
                                            !nuevo ?
                                                <>
                                                    <ButtonSpinner
                                                        variant="danger" type="button" className=""
                                                        handleSubmit={() => setshowConfirm_DELETE(true)} fetchDataLoading={[false]}
                                                        value={Lang('DAR_DE_BAJA')} icon={<FontAwesomeIcon icon={faTrash} className='me-1' />}
                                                    />
                                                    <ButtonSpinner
                                                        variant="secondary" type="button" className=""
                                                        handleSubmit={handleSubmitEditar} fetchDataLoading={[fetchAparatoPATCHData.loading]}
                                                        value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} className='me-1' />}
                                                    />
                                                </> :
                                                <>
                                                    <div></div>
                                                    <ButtonSpinner
                                                        variant="secondary" type="button" className=""
                                                        handleSubmit={handleSubmitfetchAparatoPOST} fetchDataLoading={[fetchAparatoPOSTData.loading]}
                                                        value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} className='me-1' />}
                                                    />
                                                </>
                                        }

                                    </div>

                                </div>

                            </>
                        )
                }

            </div>

            <ModalConfirm
                handleClose={() => setshowConfirm_DELETE(false)}
                show={showConfirm_DELETE}
                onClickOK={handleSubmitAparatoDELETE}
                messageHTML={
                    <h5 className='text-center fw-normal'>{Lang('PARRAFO_SEGURO_ELIMINAR_ELEMENTO')}</h5>
                }
                textOnClickOk='Sí, eliminar'
                fetchData={fetchAparatoDELETE_BAJAData}
            />

            <ModalCropImage
                show={showModalCropImage}
                handleClose={handleCloseModalCropImage}
                height='500px'
                setInputFile={setInputFileImage}
                handleSubirImagen={handleSubirImagen}
                tipo='fotografia'
                escalas={[
                    { x: 10, y: 10, label: 'Cuadrado' }
                ]}
            />

            <ModalStatusServer fetchData={fetchAparatoPOSTData} />

            <ModalStatusServer fetchData={fetchAparatoPATCHData} />

        </div>
    )
}
